import { CalendarDays, Filter, Globe, Grid3x3, ImageUp, LogOut, Menu, User } from 'lucide-react';
import { Link, NavLink } from 'react-router';

import { Dropdown } from '@/components/Dropdown';

interface HeaderProps {
  onLogout: () => void;
}

const navLinkClassName = ({ isActive }: { isActive: boolean }) =>
  `p-2 rounded-full cursor-pointer hover:bg-gray-100 ${isActive ? 'bg-gray-200' : ''}`;
const iconClassName = 'w-5 h-5 text-gray-600 hover:text-black';

export const Header = ({ onLogout }: HeaderProps) =>
  <header className="h-17">
    <nav className="flex items-center justify-between w-full px-6 py-4 bg-white shadow-sm">
      <div className="flex items-center gap-4">
        <Dropdown label={<Menu className="w-5 text-gray-600 rounded-full h5" />}>
          <Link
            to="/users"
            className="flex items-center w-full px-4 py-2 text-sm rounded-tr-lg hover:bg-gray-200 dropdown-menu-item"
          >
            <User className="w-4 h-4 mr-2" />
            Users
          </Link>
          <button
            onClick={onLogout}
            className="flex items-center w-full px-4 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-200 dropdown-menu-item"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </button>
        </Dropdown>
        <Link to="/photos" className="flex items-center">
          <span className="hidden font-medium text-gray-800 md:inline">Nuvole </span><span className="font-medium text-gray-800">⛅</span>
        </Link>
      </div>
      <div className="flex items-center gap-4">
        <NavLink to="/photos" end className={navLinkClassName} aria-label="Photos Grid">
          <Grid3x3 className={iconClassName} />
        </NavLink>
        <NavLink to="/photos/filter" end className={navLinkClassName} aria-label="Filter Photos">
          <Filter className={iconClassName} />
        </NavLink>
        <NavLink to="/photos/calendar" end className={navLinkClassName} aria-label="Calendar View">
          <CalendarDays className={iconClassName} />
        </NavLink>
        <NavLink to="/photos/map" end className={navLinkClassName} aria-label="Map View">
          <Globe className={iconClassName} />
        </NavLink>
        <NavLink to="/photos/upload" end className={navLinkClassName} aria-label="Upload Photos">
          <ImageUp className={iconClassName} />
        </NavLink>
      </div>
    </nav>
  </header>
  ;

export default Header;
